import React from "react";
import {
  Row,
  Col,
  Button,
  PopoverHeader,
  PopoverBody,
  UncontrolledPopover,
} from "reactstrap";

const Popover = ({
  text,
  header,
  id,
  content,
  placement = "left",
  trigger = "focus",
  hidePopover = false,
  popperClassName,
}) => {
  return (
    <span>
      {!hidePopover && text ? (
        <>
          <Button
            className="linked-button external-link"
            id={id}
            type="button"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            {text}
          </Button>
          <UncontrolledPopover
            placement={placement}
            trigger={trigger}
            target={id}
            popperClassName={popperClassName}
          >
            <PopoverHeader>
              <Row>
                <Col>{header}</Col>
                <Col className="text-right">
                  <i className="fa fa-times cursor-pointer"></i>
                </Col>
              </Row>
            </PopoverHeader>
            <PopoverBody>{content}</PopoverBody>
          </UncontrolledPopover>
        </>
      ) : (
        text
      )}
    </span>
  );
};

export default Popover;
